import React from 'react';
import Provider from './CreatePacingContext';
import CreatePacingContent from './CreatePacingContent';

const CreatePacing = () => {
    return (
        <Provider>
            <CreatePacingContent />
        </Provider>
    );
};

export default CreatePacing;
